/**
 * Settings State Management
 * Redux slice for managing application settings like theme preferences
 * @module Settings/Reducer
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SettingsState } from '../../../interfaces/redux/settings';

/**
 * Initial settings state
 * @type {SettingsState}
 */
const initialState: SettingsState = {
  isDarkMode: false,
};

/**
 * Settings Redux slice
 * Manages application settings including theme mode
 */
export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    /**
     * Sets dark mode to specified state
     * @param {SettingsState} state - Current settings state
     * @param {PayloadAction<boolean>} action - Action with boolean payload indicating dark mode state
     */
    setDark: (state, action: PayloadAction<boolean>) => {
      state.isDarkMode = action.payload;
    },

    /**
     * Toggles dark mode between true and false
     * @param {SettingsState} state - Current settings state
     */
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setDark, toggleDarkMode } = settingsSlice.actions;

export default settingsSlice.reducer;
